/**
 * Sidebar ad slot.
 *
 * Renders nothing until a real creative is wired up. The placeholder it used
 * to ship (`https://placehold.co/300x250`) cost every article page a DNS+TLS
 * handshake to a third-party origin, and because a plain `<img>` defaults to
 * eager loading, React hoisted it into `<head>` as a high-priority
 * `<link rel="preload" as="image">` — competing with the article hero for LCP
 * bandwidth. It was also wrapped in `<a href="#">`, a dead link on every
 * article page.
 *
 * When a real ad lands here: give the `<img>` explicit width/height (the slot
 * is 300x250) and `loading="lazy"`, and preconnect the ad origin in __root.
 */
export function ArticleAd() {
  return null;
}
